var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvisedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 104,
    viewBox: "0 0 304 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_37026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9452 56.0308C78.9452 56.0308 79.0685 77.0013 78.9452 91.9294C78.9452 97.4979 74.2634 102 68.4726 102H0M109 56.4358H34.2764C34.2764 29.644 54.0917 8 78.743 8C103.394 8 123.328 29.644 123.328 56.4358M91.5 101.997H1216",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_37026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisedIcon);
export default __webpack_public_path__ + "static/media/advised-icon.a82be501.svg";
export { ForwardRef as ReactComponent };